// Отметка о том, что пользователь сам выбрал язык кабинета.
// Детектор i18next кэширует любой язык (в том числе определённый по браузеру)
// в localStorage, поэтому по нему нельзя отличить явный выбор.
const LANGUAGE_CHOSEN_KEY = "languageChosen";

export function markLanguageChosen() {
  try {
    localStorage.setItem(LANGUAGE_CHOSEN_KEY, "1");
  } catch (error) {
    // localStorage недоступен: выбор просто не запоминаем
  }
}

// search: строка запроса страницы; язык в адресе (?lng=) тоже явный выбор
export function isLanguageChosen(search = "") {
  if (new URLSearchParams(search).has("lng")) {
    return true;
  }

  try {
    return localStorage.getItem(LANGUAGE_CHOSEN_KEY) === "1";
  } catch (error) {
    return false;
  }
}
